import type { AppLocation } from './location$';
import { pathTo } from './pathTo';
import type { UnstyledLinkProps } from '@ardoq/link';
import { navigate } from './streamRouterAdapter/actions';
import { toDispatchingProps, type PropsReturningActions } from '@ardoq/rxbeach';
import { trackingData, type TrackingEvent } from 'tracking/trackPayload';

type ToLinkPropsOptions = {
  trackingEvent?: TrackingEvent;
};

/**
 * Prop mapper for {@link Link}.
 *
 * @see {@link toLinkPropsReturningActions} for the `toDispatchingProps` version of this.
 * @param location Location the link should navigate to.
 * @returns Props for use in {@link Link} component.
 */
export const toLinkProps = (
  location: AppLocation,
  options?: ToLinkPropsOptions
): UnstyledLinkProps =>
  toDispatchingProps(toLinkPropsReturningActions(location, options));

/**
 * `toDispatchingProps`-style prop mapper for {@link Link}.
 *
 * @see {@link toLinkProps} for the "vanilla" version of this.
 * @param location Location the link should navigate to.
 * @returns Props suitable for {@link Link} when using `toDispatchingProps`.
 */
export const toLinkPropsReturningActions = (
  location: AppLocation,
  options?: ToLinkPropsOptions
): PropsReturningActions<UnstyledLinkProps> => ({
  href: pathTo(location.route, location.params, location.searchParams),
  onClick: () =>
    navigate({ ...location, [trackingData]: options?.trackingEvent }),
});

export const toExternalLinkProps = (href: string): UnstyledLinkProps => ({
  href,
  target: '_blank',
});
